import { STORE_AUTH, STORE_USER_PROFILE } from '../actions/AuthActions';

export function auth(state = null, action) {
    switch (action.type) {
        case STORE_AUTH:
            return Object.assign({}, state, { auth: action.auth });
        case STORE_USER_PROFILE:
            return Object.assign({}, state, { profile: action.profile });
        default:
            return state;
    }
}

export default auth;


// WEBPACK FOOTER //
// ./src/reducers/auth.js